import axios from "axios";
import Cookies from "universal-cookie";
import Config from "../../config/index";
import {
  ADD_ATTACHMENTS_FAILURE,
  ADD_ATTACHMENTS_REQUEST,
  ADD_ATTACHMENTS_SUCCESS,
  ADD_TICKET_COMMENTS_FAILURE,
  ADD_TICKET_COMMENTS_REQUEST,
  ADD_TICKET_COMMENTS_SUCCESS,
  CREATE_REPORT_TICKET_FAILURE,
  CREATE_REPORT_TICKET_REQUEST,
  CREATE_REPORT_TICKET_SUCCESS,
  GET_CLIENT_TICKETS_STATUS_FAILURE,
  GET_CLIENT_TICKETS_STATUS_FOR_ACTIVE_FAILURE,
  GET_CLIENT_TICKETS_STATUS_FOR_ACTIVE_REQUEST,
  GET_CLIENT_TICKETS_STATUS_FOR_ACTIVE_SUCCESS,
  GET_CLIENT_TICKETS_STATUS_REQUEST,
  GET_CLIENT_TICKETS_STATUS_SUCCESS,
  GET_COMPLETED_TICKETS_FAILURE,
  GET_COMPLETED_TICKETS_REQUEST,
  GET_COMPLETED_TICKETS_SUCCESS,
  GET_REPORTED_TICKETS_FAILURE,
  GET_REPORTED_TICKETS_REQUEST,
  GET_REPORTED_TICKETS_SUCCESS,
  GET_REQUESTTYPES_FAILURE,
  GET_REQUESTTYPES_REQUEST,
  GET_REQUESTTYPES_SUCCESS,
  GET_TICKET_COMMENTS_FAILURE,
  GET_TICKET_COMMENTS_REQUEST,
  GET_TICKET_COMMENTS_SUCCESS,
  GET_TICKET_STATUS_FAILURE,
  GET_TICKET_STATUS_REQUEST,
  GET_TICKET_STATUS_SUCCESS,
  GET_USERS_BY_CLIENT_FAILURE,
  GET_USERS_BY_CLIENT_REQUEST,
  GET_USERS_BY_CLIENT_SUCCESS,
  RE_OPEN_TICKET_FAILURE,
  RE_OPEN_TICKET_REQUEST,
  RE_OPEN_TICKET_SUCCESS,
  TICKET_HOMEPAGE_FAILURE,
  TICKET_HOMEPAGE_REQUEST,
  TICKET_HOMEPAGE_SUCCESS,
} from "./clientTicketTypes";
let baseUrl = Config.baseUrl;
let serviceDeskId = Config.serviceDeskId;

const cookies = new Cookies();

const getReportedTicketsForClientRequest = () => {
  return {
    type: GET_REPORTED_TICKETS_REQUEST,
  };
};

const getReportedTicketsForClientSuccess = (payload) => {
  return {
    type: GET_REPORTED_TICKETS_SUCCESS,
    payload: payload,
  };
};

const getReportedTicketsForClientFaliure = (error) => {
  return {
    type: GET_REPORTED_TICKETS_FAILURE,
    payload: error,
  };
};

const getReportedTicketsForClient = (payload, token) => {
  return (dispatch) => {
    dispatch(getReportedTicketsForClientRequest());
    let url = `${baseUrl}/jira/requests/requests_by_reporter`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .post(url, payload, config)
      .then((response) => {
        dispatch(getReportedTicketsForClientSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(getReportedTicketsForClientFaliure(err.message));
        return { status: false, message: err.message };
      });
  };
};
const createTicketForClientRequest = () => {
  return {
    type: CREATE_REPORT_TICKET_REQUEST,
  };
};

const createTicketForClientSuccess = (payload) => {
  return {
    type: CREATE_REPORT_TICKET_SUCCESS,
    payload: payload,
  };
};

const createTicketForClientFaliure = (error) => {
  return {
    type: CREATE_REPORT_TICKET_FAILURE,
    payload: error,
  };
};

const createTicketForClient = (payload, token) => {
  return (dispatch) => {
    dispatch(createTicketForClientRequest());
    let url = `${baseUrl}/jira/requests`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return axios
      .post(url, payload, config)
      .then((response) => {
        dispatch(createTicketForClientSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createTicketForClientFaliure(err.message));
        return { status: false, message: err.message };
      });
  };
};
const getRequestTypesForClientRequest = () => {
  return {
    type: GET_REQUESTTYPES_REQUEST,
  };
};

const getRequestTypesForClientSuccess = (payload) => {
  return {
    type: GET_REQUESTTYPES_SUCCESS,
    payload: payload,
  };
};

const getRequestTypesForClientFaliure = (error) => {
  return {
    type: GET_REQUESTTYPES_FAILURE,
    payload: error,
  };
};

const getRequestTypesForClient = (token) => {
  return (dispatch) => {
    dispatch(getRequestTypesForClientRequest());
    let url = `${baseUrl}/jira/requests/requesttypes?desk_id=${serviceDeskId}`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getRequestTypesForClientSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getRequestTypesForClientFaliure(err.message));
      });
  };
};
const addAttachmentsForClientRequest = () => {
  return {
    type: ADD_ATTACHMENTS_REQUEST,
  };
};

const addAttachmentsForClientSuccess = (payload) => {
  return {
    type: ADD_ATTACHMENTS_SUCCESS,
    payload: payload,
  };
};

const addAttachmentsForClientFaliure = (error) => {
  return {
    type: ADD_ATTACHMENTS_FAILURE,
    payload: error,
  };
};

const addAttachmentsForClient = (payload, token) => {
  return (dispatch) => {
    dispatch(addAttachmentsForClientRequest());
    let url = `${baseUrl}/jira/requests/add_attachments`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return axios
      .post(url, payload, config)
      .then((response) => {
        dispatch(addAttachmentsForClientSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(addAttachmentsForClientFaliure(err.message));
        return { status: false, message: err.message };
      });
  };
};
const getTicketStatusForClientRequest = () => {
  return {
    type: GET_TICKET_STATUS_REQUEST,
  };
};

const getTicketStatusForClientSuccess = (payload) => {
  return {
    type: GET_TICKET_STATUS_SUCCESS,
    payload: payload,
  };
};

const getTicketStatusForClientFaliure = (error) => {
  return {
    type: GET_TICKET_STATUS_FAILURE,
    payload: error,
  };
};
const getTicketStatusForClient = (id, token) => {
  return (dispatch) => {
    dispatch(getTicketStatusForClientRequest());
    let url = `${baseUrl}/jira/requests/request_by_id?issue_id=${id}`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getTicketStatusForClientSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getTicketStatusForClientFaliure(err.message));
      });
  };
};
const getTicketCommentsForClientRequest = () => {
  return {
    type: GET_TICKET_COMMENTS_REQUEST,
  };
};

const getTicketCommentsForClientSuccess = (payload) => {
  return {
    type: GET_TICKET_COMMENTS_SUCCESS,
    payload: payload,
  };
};

const getTicketCommentsForClientFaliure = (error) => {
  return {
    type: GET_TICKET_COMMENTS_FAILURE,
    payload: error,
  };
};

const getTicketCommentsForClient = (id, email, token) => {
  return (dispatch) => {
    dispatch(getTicketCommentsForClientRequest());
    let url = `${baseUrl}/jira/requests/comments?issue_id=${id}&email=${email}`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getTicketCommentsForClientSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getTicketCommentsForClientFaliure(err.message));
      });
  };
};

const getUsersByClientRequest = () => {
  return {
    type: GET_USERS_BY_CLIENT_REQUEST,
  };
};

const getUsersByClientSuccess = (payload) => {
  return {
    type: GET_USERS_BY_CLIENT_SUCCESS,
    payload: payload,
  };
};

const getUsersByClientFaliure = (error) => {
  return {
    type: GET_USERS_BY_CLIENT_FAILURE,
    payload: error,
  };
};

const getUsersByClient = (selectedClient, token) => {
  return (dispatch) => {
    dispatch(getUsersByClientRequest());
    let url = `${baseUrl}/users_management/users/user_by_clientId?client_id=${selectedClient}`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getUsersByClientSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getUsersByClientFaliure(err.message));
      });
  };
};

const addTicketCommentForClientRequest = () => {
  return {
    type: ADD_TICKET_COMMENTS_REQUEST,
  };
};

const addTicketCommentForClientSuccess = (payload) => {
  return {
    type: ADD_TICKET_COMMENTS_SUCCESS,
    payload: payload,
  };
};

const addTicketCommentForClientFaliure = (error) => {
  return {
    type: ADD_TICKET_COMMENTS_FAILURE,
    payload: error,
  };
};

const addTicketCommentForClient = (payload, token) => {
  return (dispatch) => {
    dispatch(addTicketCommentForClientRequest());
    let url = `${baseUrl}/jira/requests/add_comment`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return axios
      .post(url, payload, config)
      .then((response) => {
        dispatch(addTicketCommentForClientSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(addTicketCommentForClientFaliure(err.message));
        return { status: false, message: err.message };
      });
  };
};

const reopenTicketForClientRequest = () => {
  return {
    type: RE_OPEN_TICKET_REQUEST,
  };
};

const reopenTicketForClientSuccess = (payload) => {
  return {
    type: RE_OPEN_TICKET_SUCCESS,
    payload: payload,
  };
};

const reopenTicketForClientFailure = (error) => {
  return {
    type: RE_OPEN_TICKET_FAILURE,
    payload: error,
  };
};

const reopenTicketForClient = (payload, token) => {
  return (dispatch) => {
    dispatch(reopenTicketForClientRequest());
    let url = `${baseUrl}/jira/requests/reopen_ticket`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    return axios
      .put(url, payload, config)
      .then((response) => {
        dispatch(reopenTicketForClientSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(reopenTicketForClientFailure(err.message));
        return { status: false, message: err.message };
      });
  };
};

const ticketHomePageForClientRequest = () => {
  return {
    type: TICKET_HOMEPAGE_REQUEST,
  };
};

const ticketHomePageForClientSuccess = (payload) => {
  return {
    type: TICKET_HOMEPAGE_SUCCESS,
    payload: payload,
  };
};

const ticketHomePageForClientFaliure = (error) => {
  return {
    type: TICKET_HOMEPAGE_FAILURE,
    payload: error,
  };
};

const ticketHomePageForClient = (token) => {
  return (dispatch) => {
    dispatch(ticketHomePageForClientRequest());
    let url = `${baseUrl}/jira/requests/get_issue_count_for_all_clients`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(ticketHomePageForClientSuccess(response.data));
      })
      .catch((err) => {
        dispatch(ticketHomePageForClientFaliure(err.message));
      });
  };
};
const getCompletedTicketsForClientsRequest = () => {
  return {
    type: GET_COMPLETED_TICKETS_REQUEST,
  };
};

const getCompletedTicketsForClientsSuccess = (payload) => {
  return {
    type: GET_COMPLETED_TICKETS_SUCCESS,
    payload: payload,
  };
};

const getCompletedTicketsForClientsFaliure = (error) => {
  return {
    type: GET_COMPLETED_TICKETS_FAILURE,
    payload: error,
  };
};
const getCompletedTicketsForClients = (token) => {
  return (dispatch) => {
    dispatch(getCompletedTicketsForClientsRequest());
    let url = `${baseUrl}/jira/requests/request_by_id?`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getCompletedTicketsForClientsSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getCompletedTicketsForClientsFaliure(err.message));
      });
  };
};

const getClientTicketsByStatusForCompletedRequest = () => {
  return {
    type: GET_CLIENT_TICKETS_STATUS_REQUEST,
  };
};

const getClientTicketsByStatusForCompletedSuccess = (payload) => {
  return {
    type: GET_CLIENT_TICKETS_STATUS_SUCCESS,
    payload: payload,
  };
};

const getClientTicketsByStatusForCompletedFaliure = (error) => {
  return {
    type: GET_CLIENT_TICKETS_STATUS_FAILURE,
    payload: error,
  };
};

const getClientTicketsByStatusForCompleted = (clientId, token) => {
  return (dispatch) => {
    dispatch(getClientTicketsByStatusForCompletedRequest());
    let url = `${baseUrl}/jira/requests/get_issues_by_clientId?clientId=${clientId}&status=Completed`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(
          getClientTicketsByStatusForCompletedSuccess(response.data.data),
        );
      })
      .catch((err) => {
        dispatch(getClientTicketsByStatusForCompletedFaliure(err.message));
      });
  };
};
const getClientTicketsForActiveRequest = () => {
  return {
    type: GET_CLIENT_TICKETS_STATUS_FOR_ACTIVE_REQUEST,
  };
};

const getClientTicketsForActiveSuccess = (payload) => {
  return {
    type: GET_CLIENT_TICKETS_STATUS_FOR_ACTIVE_SUCCESS,
    payload: payload,
  };
};

const getClientTicketsForActiveFaliure = (error) => {
  return {
    type: GET_CLIENT_TICKETS_STATUS_FOR_ACTIVE_FAILURE,
    payload: error,
  };
};

const getClientTicketsForActive = (clientId, token) => {
  return (dispatch) => {
    dispatch(getClientTicketsForActiveRequest());
    let url = `${baseUrl}/jira/requests/get_issues_by_clientId?clientId=${clientId}&status=Active`;
    let config = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then((response) => {
        dispatch(getClientTicketsForActiveSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(getClientTicketsForActiveFaliure(err.message));
      });
  };
};
export {
  addAttachmentsForClient,
  addTicketCommentForClient,
  createTicketForClient,
  getClientTicketsByStatusForCompleted,
  getClientTicketsForActive,
  getCompletedTicketsForClients,
  getReportedTicketsForClient,
  getRequestTypesForClient,
  getTicketCommentsForClient,
  getTicketStatusForClient,
  getUsersByClient,
  reopenTicketForClient,
  ticketHomePageForClient,
};
